import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import lichenplanus from "../../Assets/Projects/lichenplanus.png";
import littlelemon from "../../Assets/Projects/littlelemon.png";
import pic2pixel from "../../Assets/Projects/pic2pixel.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Personal <strong className="blue">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few small projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={littlelemon}
              isBlog={false}
              title="Little Lemon Restaurant"
              description="Designed and developed a responsive restaurant reservation system, enabling users to easily book tables online. The system featured an optimized design for all devices, a seamless and interactive interface built with React components, a user-friendly booking process, and real-time table availability to prevent overbooking. Technologies used are React JS, JavaScript, CSS, and HTML."
              ghLink="https://github.com/cleomark/React-lemon-restaurant"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pic2pixel}
              isBlog={false}
              title="Pic2Pixel Application"
              description="Conceptualized and designed a user-friendly interface for an Android app focused on text image conversion. Implemented the interface using Flutter, employing various widgets and libraries for robust functionality. Developed core features for transforming text images into digital text and ensured a seamless user experience. Technologies used are Dart, Flutter, Figma, and Python."
              ghLink="https://github.com/cleomark/pic2pixel_app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lichenplanus}
              isBlog={false}
              title="Lichen Planus Detector Application"
              description="Planus Identifier is a medical diagnostic tool that detects and monitors lichen planus skin rash using image processing. It analyzes and classifies digital images of skin areas to identify the rash type. The system enables mobile identification of lichen planus with specific camera features. Technologies used are Flutter, Python 3.8, TensorFlow API, TensorFlow Lite, and Android Studio."
              ghLink="https://github.com/cleomark/LichenPlanusDetectionApp"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
